/* ============================================================
   dz-cart-main.js — MAIN cart page (/cart) interactions
   - Compact density toggle (persisted)
   - 60-day returns tooltip tap (mobile)
   - Share (copy product link)
   - Save for later (localStorage MVP)
   Uses event delegation so it survives Be Yours section re-renders.
   ============================================================ */
(function () {
  'use strict';

  var LS_COMPACT = 'dz-cart-compact';
  var LS_SAVED = 'dz-cart-saved';

  /* ---------- helpers ---------- */
  function table() { return document.getElementById('dz-cart-items-table'); }
  function readSaved() {
    try { return JSON.parse(localStorage.getItem(LS_SAVED) || '[]'); } catch (e) { return []; }
  }
  function writeSaved(arr) { localStorage.setItem(LS_SAVED, JSON.stringify(arr)); }
  // Shopify's `item.properties | json` renders as an ARRAY of [key,value] pairs, and the
  // template's `| escape` leaves the values HTML-entity-encoded (&quot; &amp; &lt; ...).
  // /cart/add.js needs a plain {key:value} OBJECT with real characters, so normalize both here.
  function decodeEntities(s) {
    if (typeof s !== 'string' || s.indexOf('&') === -1) return s;
    var d = document.createElement('textarea'); d.innerHTML = s; return d.value;
  }
  function parseProps(raw) {
    if (!raw) return {};
    var v; try { v = JSON.parse(raw); } catch (e) { return {}; }
    var obj = {};
    if (Array.isArray(v)) {
      v.forEach(function (p) {
        if (Array.isArray(p) && p.length >= 2) obj[decodeEntities(String(p[0]))] = decodeEntities(p[1]);
      });
    } else if (v && typeof v === 'object') {
      Object.keys(v).forEach(function (k) { obj[decodeEntities(k)] = decodeEntities(v[k]); });
    }
    return obj;
  }
  function flash(el, msg) {
    if (!el) return;
    el.textContent = msg;
    el.classList.add('dz-show');
    setTimeout(function () { el.classList.remove('dz-show'); }, 1800);
  }

  /* ---------- share modal ---------- */
  function openShareModal(url, title) {
    var modal = document.getElementById('dz-share-modal');
    if (!modal || !url) return;
    title = title || 'this product';
    var enc = encodeURIComponent, eurl = enc(url), etitle = enc(title);
    var set = function (id, href) { var a = document.getElementById(id); if (a) a.href = href; };
    set('dz-share-email', 'mailto:?subject=' + enc('Check out ' + title + ' on DezLin') +
      '&body=' + enc('I thought you might like this:\n\n' + title + '\n' + url));
    set('dz-share-pinterest', 'https://pinterest.com/pin/create/button/?url=' + eurl + '&description=' + etitle);
    set('dz-share-facebook', 'https://www.facebook.com/sharer/sharer.php?u=' + eurl);
    set('dz-share-x', 'https://twitter.com/intent/tweet?url=' + eurl + '&text=' + etitle);
    var sub = document.getElementById('dz-share-modal-sub');
    if (sub) sub.textContent = title;
    var su = document.getElementById('dz-share-url');
    if (su) su.value = url;
    var fb = document.getElementById('dz-share-feedback');
    if (fb) { fb.textContent = ''; fb.classList.remove('dz-show'); }
    modal.hidden = false;
    document.body.classList.add('dz-share-open');
  }
  function closeShareModal() {
    var modal = document.getElementById('dz-share-modal');
    if (modal) modal.hidden = true;
    document.body.classList.remove('dz-share-open');
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeShareModal();
  });

  /* ---------- compact density ---------- */
  function applyCompact(on) {
    var t = table();
    if (t) t.classList.toggle('cart-items--compact', on);
    var btn = document.getElementById('dz-compact-toggle');
    if (btn) btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  }
  function initCompact() {
    // Compact view was retired (toggle removed) — always render the full layout,
    // and clear any stale stored pref so no one is stranded in compact.
    try { localStorage.removeItem(LS_COMPACT); } catch (e) {}
    applyCompact(false);
  }

  /* ---------- saved for later ---------- */
  function renderSaved() {
    var host = document.getElementById('main-cart-items');
    if (!host) return;
    var existing = document.getElementById('dz-saved-section');
    var saved = readSaved();
    if (!saved.length) { if (existing) existing.remove(); return; }

    var esc = function (str) { var d = document.createElement('div'); d.textContent = str == null ? '' : str; return d.innerHTML; };
    var cards = saved.map(function (s, i) {
      var img = s.image
        ? '<img class="dz-saved__img" src="' + esc(s.image) + '" alt="" loading="lazy">'
        : '<div class="dz-saved__img dz-saved__img--ph" aria-hidden="true">🛍</div>';
      var titleInner = esc(s.title || 'Item');
      var title = s.url ? '<a class="dz-saved__title" href="' + esc(s.url) + '">' + titleInner + '</a>'
                        : '<span class="dz-saved__title">' + titleInner + '</span>';
      return '<li class="dz-saved__card">' +
        img +
        '<div class="dz-saved__info">' +
          title +
          (s.details ? '<div class="dz-saved__meta">' + esc(s.details) + '</div>' : '') +
          (s.price ? '<div class="dz-saved__price">' + esc(s.price) + '</div>' : '') +
          '<div class="dz-saved__actions">' +
            '<button type="button" class="dz-saved__move" data-i="' + i + '">+ Move to cart</button>' +
            '<button type="button" class="dz-saved__del" data-i="' + i + '">Remove</button>' +
          '</div>' +
        '</div>' +
      '</li>';
    }).join('');

    var html = '<div class="dz-saved">' +
      '<div class="dz-saved__hd"><span class="dz-saved__hd-icon" aria-hidden="true">🔖</span> Saved for later' +
        '<span class="dz-saved__count">' + saved.length + '</span></div>' +
      '<ul class="dz-saved__list">' + cards + '</ul></div>';

    if (existing) { existing.innerHTML = html; }
    else {
      var wrap = document.createElement('div');
      wrap.id = 'dz-saved-section';
      wrap.innerHTML = html;
      // Insert AFTER the cart form (.cart__contents), not inside it — Be Yours hides the form when
      // the cart is empty, so an in-form saved section would disappear on an empty cart.
      var anchor = host.closest('.cart__contents') || host;
      anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    }
  }

  function moveToCart(idx) {
    var saved = readSaved();
    var item = saved[idx];
    if (!item) return;
    // rebuild the line EXACTLY, including Zepto/Infinite-Options personalization (line-item properties)
    var body = { id: item.variantId, quantity: item.qty || 1 };
    if (item.properties && Object.keys(item.properties).length) body.properties = item.properties;
    if (item.sellingPlan) body.selling_plan = item.sellingPlan;
    function done() { saved.splice(idx, 1); writeSaved(saved); window.location.reload(); }
    function fail(msg) {
      console.error('[dz save-for-later] move-to-cart failed:', msg, body);
      alert('Could not add this back to the cart:\n\n' + msg + '\n\nThe item is still saved, nothing was lost.');
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.text().then(function (t) { var d = {}; try { d = JSON.parse(t); } catch (e) {} return { ok: r.ok, status: r.status, data: d }; });
    }).then(function (res) {
      if (res.ok) { done(); return; }
      var msg = (res.data && (res.data.description || res.data.message)) || ('add failed, HTTP ' + res.status);
      // If the personalization properties are what Shopify rejected, retry WITHOUT them so at least
      // the product returns to the cart (rather than vanishing), and tell the user detail was dropped.
      if (body.properties) {
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: item.variantId, quantity: item.qty || 1 })
        }).then(function (r2) {
          if (r2.ok) { alert('Added back to the cart, but the personalization could not be restored automatically:\n\n' + msg); done(); }
          else { fail(msg); }
        }).catch(function () { fail(msg); });
      } else { fail(msg); }
    }).catch(function (e) { fail('network error, ' + (e && e.message ? e.message : e)); });
  }

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    // compact toggle
    if (t.closest && t.closest('#dz-compact-toggle')) {
      var nowOn = !(table() && table().classList.contains('cart-items--compact'));
      localStorage.setItem(LS_COMPACT, nowOn ? '1' : '0');
      applyCompact(nowOn);
      return;
    }

    // returns tooltip tap (toggle)
    var rbtn = t.closest && t.closest('.dz-returns__btn');
    if (rbtn) {
      var wrap = rbtn.closest('.dz-returns');
      if (wrap) wrap.classList.toggle('dz-open');
      return;
    }

    // share -> open the share modal (populated from the clicked button)
    var share = t.closest && t.closest('.dz-li-share');
    if (share) {
      openShareModal(share.getAttribute('data-share-url'), share.getAttribute('data-title'));
      return;
    }

    // share modal: copy link
    if (t.closest && t.closest('#dz-share-copy')) {
      var su = document.getElementById('dz-share-url');
      var sfb = document.getElementById('dz-share-feedback');
      var url = su ? su.value : '';
      var done = function () { flash(sfb, 'Link copied'); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(function () {
          if (su) { su.select(); document.execCommand && document.execCommand('copy'); done(); }
        });
      } else if (su) { su.select(); document.execCommand && document.execCommand('copy'); done(); }
      return;
    }

    // share modal: close
    if (t.closest && t.closest('[data-share-close]')) { closeShareModal(); return; }

    // save for later
    var save = t.closest && t.closest('.dz-li-save');
    if (save) {
      var saved = readSaved();
      var vid = parseInt(save.getAttribute('data-variant-id'), 10);
      var props = parseProps(save.getAttribute('data-properties'));
      var sp = parseInt(save.getAttribute('data-selling-plan'), 10) || null;
      var pkey = JSON.stringify(props);
      // dedup by variant AND personalization, so two different customizations of the same product both survive
      if (!saved.some(function (s) { return s.variantId === vid && JSON.stringify(s.properties || {}) === pkey; })) {
        saved.push({
          variantId: vid,
          qty: parseInt(save.getAttribute('data-qty'), 10) || 1,
          handle: save.getAttribute('data-handle'),
          title: save.getAttribute('data-title'),
          details: save.getAttribute('data-details') || '',
          properties: props,
          sellingPlan: sp,
          image: save.getAttribute('data-image') || '',
          price: save.getAttribute('data-price') || '',
          url: save.getAttribute('data-url') || ''
        });
        writeSaved(saved);
      }
      // remove from cart (the remove URL returns to /cart)
      var removeUrl = save.getAttribute('data-remove-url');
      if (removeUrl) window.location.href = removeUrl;
      return;
    }

    // saved-section: move / remove
    var mv = t.closest && t.closest('.dz-saved__move');
    if (mv) { moveToCart(parseInt(mv.getAttribute('data-i'), 10)); return; }
    var del = t.closest && t.closest('.dz-saved__del');
    if (del) {
      var arr = readSaved();
      arr.splice(parseInt(del.getAttribute('data-i'), 10), 1);
      writeSaved(arr);
      renderSaved();
      return;
    }
  });

  // close returns tooltip on outside tap
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.dz-returns')) return;
    document.querySelectorAll('.dz-returns.dz-open').forEach(function (el) { el.classList.remove('dz-open'); });
  }, true);

  /* ---------- Amazon-style qty: trash icon at qty 1 ---------- */
  function syncQtyTrash() {
    document.querySelectorAll('.dz-li-actions .quantity').forEach(function (q) {
      var input = q.querySelector('.quantity__input');
      if (!input) return;
      var v = parseInt(input.value, 10);
      q.classList.toggle('dz-qty-removable', v <= 1);
    });
  }
  // Update trash state as the qty changes (before + after Be Yours re-renders)
  document.addEventListener('input', function (e) {
    if (e.target.closest && e.target.closest('.dz-li-actions .quantity')) syncQtyTrash();
  });
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.dz-li-actions .quantity')) syncQtyTrash();
  });
  // In trash mode, the minus button removes the line (capture so it pre-empts the stepper)
  document.addEventListener('click', function (e) {
    var minus = e.target.closest && e.target.closest('.dz-li-actions .dz-qty-minus');
    if (!minus) return;
    var q = minus.closest('.quantity');
    if (!q || !q.classList.contains('dz-qty-removable')) return;
    var url = minus.getAttribute('data-remove-url');
    if (!url) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = url;
  }, true);

  /* ---------- wholesale price sync ----------
     The WPD app computes the true wholesale price on its backend and writes it
     into our hidden .dz-price-hooks mirror. We read it from there and render it
     into the visible .dz-price block in Marc's format. (Server-side wcp_v_price
     is NOT reliable — it misses the app's backend discount.) */
  function money(s) { return s ? parseFloat(s.replace(/[^0-9.]/g, '')) : NaN; }
  function syncCell(cell) {
    if (!cell) return;
    var mirror = cell.querySelector('.dz-price-hooks');
    var vis = cell.querySelector('.dz-price:not(.dz-price--legacy)');
    if (!mirror || !vis) return;
    var unit = mirror.querySelector('.cart-item__price-wrapper:not([data-wpd-cart-line-price])');
    if (!unit) return;
    var sEl = unit.querySelector('s');
    var struck = sEl ? sEl.textContent.trim() : '';
    // Only sync when the WPD app has applied a wholesale discount (it injects a struck
    // retail price). For retail/guest the server-rendered visible block is already correct
    // — leave it alone (otherwise we'd overwrite the sale price + double the currency code).
    if (!struck) return;
    var txt = unit.textContent.trim();
    var ws = txt.replace(struck, '').trim();
    if (!ws || !/\d/.test(ws)) return;
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    // match the server markup: amount + small "USD" (price color) + "EA." on the selling price only
    var usdSpan = cur === 'USD' ? '<span class="dz-usd">USD</span>' : '';
    var amtEl = vis.querySelector('.dz-price__amt');
    var newAmtHtml = ws + usdSpan + '<span class="dz-ea">EA.</span>';
    if (amtEl && amtEl.innerHTML.replace(/\s+/g, ' ').trim() !== newAmtHtml) amtEl.innerHTML = newAmtHtml;
    var retailEl = vis.querySelector('.dz-price__retail');
    var pctEl = vis.querySelector('.dz-price__pct');
    if (retailEl) {
      var prefix = retailEl.textContent.indexOf('retail') === 0 ? 'retail: ' : '';
      var newRetail = prefix + '<s>' + struck + '</s>';   // struck retail has no USD (Marc r7)
      if (retailEl.innerHTML.replace(/\s+/g, ' ').trim() !== newRetail) retailEl.innerHTML = newRetail;
    }
    var o = money(struck), w = money(ws);
    if (pctEl && o > 0 && w < o) {
      var p = '-' + Math.round((o - w) / o * 100) + '%';
      if (pctEl.textContent.trim() !== p) pctEl.textContent = p;
    }
  }
  function syncWholesale() { document.querySelectorAll('.cart-item__price').forEach(syncCell); }
  function wireWholesale() {
    if (!window.MutationObserver) { syncWholesale(); return; }
    document.querySelectorAll('.dz-price-hooks').forEach(function (m) {
      if (m.__dzObs) return;
      m.__dzObs = new MutationObserver(function () { syncCell(m.closest('.cart-item__price')); });
      m.__dzObs.observe(m, { childList: true, subtree: true, characterData: true });
    });
    syncWholesale();
  }

  /* ---------- mobile price mirror ----------
     On phones the price sits right after the title. Rather than duplicate the hook-bearing
     price markup, the .dz-price--mobile block is empty + carries NO app hooks; we copy the
     RENDERED desktop visible price into it. This covers retail, wholesale (syncCell output),
     and mczr/IO items (app-injected) alike, with one source of truth and zero hook duplication. */
  /* Transform the copied desktop price for mobile (idempotent, so dst settles):
     - the "Wholesale" eyebrow becomes "WS" (desktop keeps the full word)
     - the " USD" suffix is wrapped in <span class="dz-usd"> so it can be sized down */
  function transformMobilePrice(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var lbl = tmp.querySelector('.dz-price__ws-label');
    if (lbl && lbl.textContent.trim() !== 'WS') lbl.textContent = 'WS';
    var amt = tmp.querySelector('.dz-price__amt');
    if (amt && !amt.querySelector('.dz-usd')) {
      var m = amt.textContent.match(/^([\s\S]*?)\s*USD\s*$/);
      if (m) amt.innerHTML = m[1].trim() + ' <span class="dz-usd">USD</span>';
    }
    return tmp.innerHTML;
  }
  function copyMobilePrice(row) {
    if (!row) return;
    var src = row.querySelector('.cart-item__price .dz-price');   // visible desktop price (legacy or normal); excludes the hidden .dz-price-hooks mirror
    var dst = row.querySelector('.dz-price--mobile');
    if (!src || !dst) return;
    var html = transformMobilePrice(src.innerHTML);
    if (dst.innerHTML !== html) dst.innerHTML = html;
  }
  function syncMobilePrice() { document.querySelectorAll('.cart-item').forEach(copyMobilePrice); }
  function wireMobilePrice() {
    if (!window.MutationObserver) { syncMobilePrice(); return; }
    document.querySelectorAll('.cart-item__price .dz-price').forEach(function (src) {
      if (src.__dzMobObs) return;
      src.__dzMobObs = new MutationObserver(function () { copyMobilePrice(src.closest('.cart-item')); });
      src.__dzMobObs.observe(src, { childList: true, subtree: true, characterData: true });
    });
    syncMobilePrice();
  }

  /* ---------- sort the main-cart rows (VISUAL only) ----------
     Default is "Last added" = the natural cart order (Shopify keeps lines in add-order). "By SKU"
     is opt-in via the toolbar dropdown, remembered per device. We reorder with CSS `order`, NOT by
     moving DOM nodes: moving nodes would scramble the positional updates[] inputs and any cart
     form-submit / persistent-cart save would apply quantities to the wrong lines (verified: it
     corrupts the cart). CSS order keeps the DOM (and updates[] positions) intact. Rows are
     display:grid and tbody is block, so flex+order is safe (thead is hidden). */
  var LS_SORT = 'dz-cart-sort';
  function getSort() { try { return localStorage.getItem(LS_SORT) || 'added'; } catch (e) { return 'added'; } }
  function applySort() {
    var tbody = document.querySelector('#dz-cart-items-table tbody');
    if (!tbody) return;
    var mode = getSort();
    var sel = document.getElementById('dz-cart-sort');
    if (sel && sel.value !== mode) sel.value = mode;   // keep the dropdown in sync after re-render
    var rows = Array.prototype.slice.call(tbody.querySelectorAll('tr.cart-item'));
    if (rows.length < 2) return;
    if (mode === 'sku') {
      var ranked = rows.slice().sort(function (a, b) {
        var sa = (a.getAttribute('data-sku') || '').toLowerCase();
        var sb = (b.getAttribute('data-sku') || '').toLowerCase();
        if (sa === sb) return 0;
        if (!sa) return 1; if (!sb) return -1;   // blank SKUs sink to the bottom
        return sa < sb ? -1 : 1;
      });
      tbody.style.display = 'flex';
      tbody.style.flexDirection = 'column';
      ranked.forEach(function (r, i) { r.style.order = String(i); });
    } else {
      // "Last added" = natural order; undo any visual reorder
      tbody.style.display = '';
      tbody.style.flexDirection = '';
      rows.forEach(function (r) { r.style.order = ''; });
    }
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.id === 'dz-cart-sort') {
      try { localStorage.setItem(LS_SORT, e.target.value); } catch (err) {}
      applySort();
    }
  });

  /* ---------- init + re-init after section re-render ---------- */
  // When arriving from the drawer's "View saved for later" link (/cart#dz-saved-section),
  // smooth-scroll to the saved section once it has rendered.
  function scrollToSavedIfHashed() {
    if (location.hash !== '#dz-saved-section') return;
    var el = document.getElementById('dz-saved-section');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function init() { initCompact(); applySort(); renderSaved(); wireWholesale(); syncQtyTrash(); wireMobilePrice(); scrollToSavedIfHashed(); }
  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();
  [300, 900].forEach(function (t) { setTimeout(scrollToSavedIfHashed, t); });
  // The app's price update can land after load — re-sync a few times.
  [400, 1000, 2000, 3500].forEach(function (t) { setTimeout(function () { syncWholesale(); syncMobilePrice(); }, t); });

  // Be Yours replaces #main-cart-items innerHTML on quantity change — re-apply compact + re-wire wholesale.
  var host = document.getElementById('main-cart-items');
  if (host && window.MutationObserver) {
    new MutationObserver(function () { initCompact(); applySort(); wireWholesale(); syncQtyTrash(); wireMobilePrice(); }).observe(host, { childList: true, subtree: true });
  }
})();
